export const KeyEventCodes = {
  data: () => ( {
    keyboardEvent: {
      keyCode: {
        SPACE: 32,
        LEFT: 37,
        UP: 38,
        RIGHT: 39,
        DOWN: 40,
        ENTER: 13,
        SHIFT: 16,
        BACKSPACE: 8,
        CTRL: 7,
        TAB: 9,
        DELETE: 46,
      },
    },
  } ),
};

export const navigation = {
  methods: {
    back () {
      window.history.go( -1 );
    },
    redirect ( url ) {
      window.location.href = url;
    },
  },
};

export const validation = {
  methods: {
    isValidEmail ( email ) {
      const re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      return re.test( email );
    },
  },
};

export const placeholder = {
  data: () => ( {
    defaultImage: "/Assets/images/image-placeholder.png",
  } ),
};

export const utils = {
  methods: {
    isNullOrEmpty ( val ) {
      return val == null || val === "";
    },
    getURLParams () {
      const queryParams = window.location.search
        .substr( 1 )
        .split( "&" )
        .reduce( ( q, query ) => {
          const chunks = query.split( "=" );
          const key = chunks[0];
          let value = decodeURIComponent( chunks[1] );
          value = Number.isNaN( Number( value ) ) ? value : Number( value );
          q[key] = value;
          return q;
        }, {} );

      return queryParams;
    },
    isIE () {
      const ua = window.navigator.userAgent;
      const msie = ua.indexOf( "MSIE " );

      let result = false;

      // eslint-disable-next-line
      if (msie > 0 || !!navigator.userAgent.match(/Trident.*rv\:11\./)) {
        // if Internet Explorer, log version number
        console.info( Number.parseInt( ua.substring( msie + 5, ua.indexOf( ".", msie ) ), 10 ) );
        result = true;
      }

      return result;
    },
    chunkArray ( arr, chunkSize ) {
      const results = [];
      const mutableArr = [...arr];

      while ( mutableArr.length ) {
        results.push( mutableArr.splice( 0, chunkSize ) );
      }

      return results;
    },
    scrollToTop () {
      window.scroll( {
        top: 0,
        left: 0,
        behavior: "smooth",
      } );
    },
  },
};

export const isMobile = {
  data: () => ( {
    mobileMediaQuery: null,
    isMobile: null,
  } ),
  mounted () {
    this.mobileMediaQuery = window.matchMedia( "(max-width: 767px)" ); // same definition as mobile collapsible
    this.mobileMediaQuery.addEventListener( "change", this.updateIsMobile );
    this.updateIsMobile();
  },
  beforeDestroy () {
    this.mobileMediaQuery.removeEventListener( "change", this.updateIsMobile );
  },
  methods: {
    updateIsMobile () {
      this.isMobile = this.mobileMediaQuery.matches;
    },
  },
};

export const clipboard = {
  methods: {
    copy ( txt ) {
      navigator.clipboard
        .writeText( txt )
        .then( () => {
          this.$bvToast.toast( "Copied survey link to clipboard", {
            title: "Done!",
            autoHideDelay: 600,
            variant: "success",
            toaster: "b-toaster-top-right",
            appendToast: true,
          } );
        } )
        .catch( err => {
          console.error( "Error in copying text: ", err );
          this.$bvToast.toast( "Failed to copy link, please try manually.", {
            title: "Done!",
            autoHideDelay: 600,
            variant: "danger",
            toaster: "b-toaster-bottom-right",
            appendToast: true,
          } );
        } );
    },
  },
};

export const print = {
  methods: {
    printElement ( element, appendStyleSheets = true ) {
      if ( this.isIE() ) {
        window.print();
      } else {
        const printArea = window.open();
        printArea.document.write( element.innerHTML );

        if ( appendStyleSheets ) {
          const css = document.createElement( "style" );
          css.media = "print";

          // create css stylesheet containing all of the available styles
          for ( let i = 0; i < document.styleSheets.length; i += 1 ) {
            try {
              const styleSheet = document.styleSheets[i];
              const { cssRules } = styleSheet;

              for ( let i2 = 0; i2 < cssRules.length; i2 += 1 ) {
                const rule = cssRules[i2];
                const { cssText } = rule;
                css.appendChild( document.createTextNode( cssText ) );
              }
            } catch ( ex ) {
              console.warn( ex );
            }
          }
          printArea.document.getElementsByTagName( "head" )[0].appendChild( css );
        }
        printArea.focus();
        printArea.print();
        printArea.close();
      }
    },
    print () {
      window.print();
    },
  },
};
